












import { Component, Prop, Vue } from 'vue-property-decorator';
import { PermissionType } from '@shared/common/types';
import { deviceApi } from '../device.api';
import ConfirmModal from '@/modules/core/components/ConfirmModal.vue';
import { Device } from '../device';

@Component
export default class DeviceUnassignBtn extends Vue {
  public PermissionType: typeof PermissionType = PermissionType;

  public deleting = false;

  @Prop()
  public device!: Device;

  public get isBtnVisible(): boolean {
    return this.$can(PermissionType.deleteDevice) && !this.device.deletedAt;
  }

  public openConfirmModal(): void {
    this.$buefy.modal.open({
      hasModalCard: true,
      component: ConfirmModal,
      props: {
        title: `Suppression du terminal #${this.device.incrementalId}`,
        bodyHtml: `Vous allez supprimer le terminal <b>${this.device.incrementalId}</b>.`,
        uncancellableActionWarning: true,
        confirmAction: this.deleteDevice.bind(this),
      },
    });
  }

  public async deleteDevice(): Promise<void> {
    this.deleting = true;

    try {
      await deviceApi.delete(this.device);
      this.$buefy.snackbar.open({
        message: 'Terminal supprimé',
        type: 'is-success',
      });
      this.deleting = false;
      this.$emit('deleted');
    } catch (_) {
      this.$buefy.snackbar.open({
        message: 'Erreur lors de la suppression du terminal',
        type: 'is-danger',
      });
      this.deleting = false;
      throw _;
    }
  }
}
